import React from 'react';

export const NxPanel = React.forwardRef(function NxPanel(
  { title, subtitle, action, padded = true, className = '', children, ...rest },
  ref
) {
  return (
    <section ref={ref} className={`nx-panel ${className}`.trim()} {...rest}>
      {(title || action) && (
        <header className="nx-panel-head">
          <div>
            {title && <h3 className="nx-h3" style={{ margin: 0 }}>{title}</h3>}
            {subtitle && <p className="nx-mono" style={{ fontSize: 11, color: 'var(--nx-ink-dim)', marginTop: 2 }}>{subtitle}</p>}
          </div>
          {action}
        </header>
      )}
      <div className={padded ? 'nx-panel-body' : ''}>{children}</div>
    </section>
  );
});
